import React from "react";
import { MessageCircle } from "lucide-react";

// Opens the Smartsupp live chat on demand. The native Smartsupp launcher stays
// hidden inside the dashboard (see ChatVisibility) so it never overlaps the
// bottom nav / Funds button — this button is the intentional entry point.
const openSupport = () => {
  const s = window.smartsupp;
  if (typeof s !== "function") return;

  // Pause the auto-hide enforcement while the chat is open.
  window.__nwChatManual = true;

  if (!window.__nwChatCloseBound) {
    window.__nwChatCloseBound = true;
    s("on", "chat:close", () => {
      window.__nwChatManual = false;
      if (typeof window.smartsupp === "function") window.smartsupp("chat:hide");
    });
  }

  s("chat:show");
  s("chat:open");
};

const SupportButton = () => (
  <button
    onClick={openSupport}
    data-testid="dashboard-support-btn"
    aria-label="Open live chat support"
    className="fixed z-40 right-4 bottom-24 lg:right-6 lg:bottom-6 inline-flex items-center gap-2 h-12 px-4 rounded-full bb-blue text-white text-[13px] font-semibold shadow-xl shadow-[#1c3df5]/40 hover:scale-105 active:scale-95 transition-transform"
  >
    <MessageCircle size={18} />
    <span className="hidden sm:inline">Live chat</span>
  </button>
);

export default SupportButton;
